import { useTranslation } from "react-i18next";
import { SiteFooter } from "@/components/SiteFooter";
import { ClosingCta } from "./components/ClosingCta";
import { HowItsMade } from "./components/HowItsMade";
import { InScale } from "./components/InScale";
import { LandingHero } from "./components/LandingHero";
import { MakersPromise } from "./components/MakersPromise";
import { Memorial } from "./components/Memorial";
import { NoSurprises } from "./components/NoSurprises";
import { Print3d } from "./components/Print3d";
import { ProofIsReal } from "./components/ProofIsReal";
import { UgcGallery } from "./components/UgcGallery";

// The conversion landing at `/` (ADR-0040, register per ADR-0055): a split hero
// hooks, a bolder premium-warm proof stack closes. All of it is real, crawlable
// HTML that paints immediately; zero three.js on this route.
//
// The SEO head is baked into the prerendered `<head>` by the route's Start
// `head()` via the pure `buildHead` model (ADR-0053 §1), so non-JS social
// scrapers see it.
//
// Section order is the objection-killing order: hook -> prove it looks like them
// -> show the craft (dark atelier anchor) -> real object in a real home -> the
// people behind it -> the quiet memorial thread -> real customers -> no-surprises
// trust -> the 3D-print add-on -> ask for the drop.
export function Landing() {
  const { t } = useTranslation("landing");

  return (
    <div className="flex min-h-svh flex-col bg-paper text-foreground">
      <a
        href="#main-content"
        className="sr-only rounded bg-primary px-3 py-2 text-sm font-medium text-primary-foreground focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
      >
        {t("header.skipToContent")}
      </a>
      <main id="main-content" className="flex-1">
        <LandingHero />
        <ProofIsReal />
        <HowItsMade />
        <InScale />
        <MakersPromise />
        <Memorial />
        <UgcGallery />
        <NoSurprises />
        <Print3d />
        <ClosingCta />
      </main>
      <SiteFooter />
    </div>
  );
}
